import { z } from "zod";
import { comicPageFamilyV1Schema } from "./comic-production.js";
const sha256Schema = z.string().regex(/^[a-f0-9]{64}$/);
export const comicAutomaticCompositionPolicyV1Schema = z
    .object({
    version: z.literal(1),
    policyId: z.string().min(1).max(160),
    policyVersion: z.string().min(1).max(80),
    policyHashSha256: sha256Schema,
    preserveAuthoredStructure: z.literal(true),
    maximumAutomaticInsetsPerPage: z.number().int().min(0).max(4),
    enabledCategories: z
        .array(z.enum(["LETTERING_COMPONENT", "PANEL_FRAME", "INSET", "EDITORIAL_STRUCTURE"]))
        .min(1)
        .max(4),
})
    .strict();
export const comicComponentSelectionDecisionV1Schema = z
    .object({
    version: z.literal(1),
    decisionId: z.string().min(1).max(200),
    category: z.enum(["LETTERING_COMPONENT", "PANEL_FRAME", "INSET", "EDITORIAL_STRUCTURE"]),
    outcome: z.enum(["SELECTED", "PRESERVED", "SKIPPED"]),
    targetId: z.string().min(1).max(200),
    componentId: z.string().min(1).max(160).optional(),
    structuralObjectId: z.string().min(1).max(160).optional(),
    score: z.number().min(0).max(1),
    protectedRegionIds: z.array(z.string().min(1).max(120)).max(100),
    reasons: z.array(z.string().trim().min(1).max(300)).min(1).max(12),
})
    .strict()
    .superRefine((decision, context) => {
    if (decision.outcome !== "SKIPPED" && !decision.componentId)
        context.addIssue({
            code: "custom",
            path: ["componentId"],
            message: "Selected and preserved decisions must identify the exact component.",
        });
});
export const comicAutomaticCompositionEvidenceV1Schema = z
    .object({
    version: z.literal(1),
    pageNumber: z.number().int().positive().max(200),
    inputPageHashSha256: sha256Schema,
    outputPageHashSha256: sha256Schema,
    policyId: z.string().min(1).max(160),
    policyVersion: z.string().min(1).max(80),
    policyHashSha256: sha256Schema,
    layoutFamily: comicPageFamilyV1Schema,
    authoredStructurePreserved: z.boolean(),
    preflightPassed: z.literal(true),
    decisions: z.array(comicComponentSelectionDecisionV1Schema).min(1).max(500),
    selectedStructuralObjectIds: z.array(z.string().min(1).max(160)).max(100),
})
    .strict();
//# sourceMappingURL=comic-composition-selection.js.map